

















import { computed, defineComponent, PropType } from '@nuxtjs/composition-api'
import InputRadio from '@/components/Inputs/InputRadio'
import InputError from '@/components/Inputs/new-design/InputError.vue'
type Options = {
  label: string
  value: any
}
export default defineComponent({
  name: 'InputRadioButtons',
  components: { InputError, InputRadio },
  props: {
    value: {
      require: true,
    },
    options: {
      type: Array as PropType<Options[]>,
      default: () => [],
    },
    error: {
      type: [String, Boolean],
      default: '',
    },
  },
  setup(props, { emit }) {
    const val = computed({
      get: () => props.value,
      set: (value) => {
        emit('change', value)
      },
    })
    return {
      val,
    }
  },
})
